/**
 * Removes every service line represented by the aggregated minicart row.
 * The message lives on that service line, so deleting the line removes both.
 */
(function() {
  'use strict';

  async function deleteServiceLines(aggregatedKeys) {
    const updates = {};
    aggregatedKeys
      .split(',')
      .map(key => key.trim())
      .filter(Boolean)
      .forEach(key => {
        updates[key] = 0;
      });

    if (Object.keys(updates).length === 0) return;

    // De mutatie loopt door `cart-client`, de enige plek die winkelwagenregels
    // muteert. `cart-client.js` laadt deferred vóór dit bestand, en deze
    // handler draait pas op een klik, dus hij bestaat hier altijd.
    await window.cartClient.updateCart(updates, {
      fallbackErrorMessage: 'Failed to remove greeting card service'
    });
  }

  async function refreshCart() {
    const response = await fetch('/cart.js');
    if (!response.ok) throw new Error(`Failed to refresh cart (${response.status})`);

    const cart = await response.json();
    if (typeof window.updateCart === 'function') {
      await window.updateCart(cart);
      return;
    }

    window.location.reload();
  }

  document.addEventListener('click', async event => {
    const deleteButton = event.target.closest('.js-cart-item-delete__confirm');
    const cartItem = deleteButton?.closest('[data-aggregated="true"]');
    const aggregatedKeys = cartItem?.dataset.aggregatedKeys;
    if (!aggregatedKeys) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    cartItem.classList.add('is-busy');

    try {
      await deleteServiceLines(aggregatedKeys);
      await refreshCart();
    } catch (error) {
      console.error('Failed to remove greeting card service:', error);
      cartItem.classList.remove('is-busy');
    }
  }, true);
})();
